// import external dependencies
import 'jquery';
import 'jquery-match-height/dist/jquery.matchHeight-min'
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


import "./dropdown"
import "./sticky-footer"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import profile from './routes/profile';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    home,
    profile,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js